export default  {
  controller: 'adminMenuController',
  template: require('../views/admin.menu.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/base/components/admin.menu.component.js